import pluralize from 'pluralize';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  FileStatusIconCompleted,
  FileStatusPanelItem,
  FileStatusSubtitle,
  FileStatusTitle,
  FileStatusTrackingPanelList,
  FileStatusTrackingPanelListItemCompleted,
} from '@air/feature-file-status/ui';
import { convertUploadToFileTrackingPaneItem } from '@air/feature-uploads/utils';

import { contentCollectionSubmittedClipsSelector } from '../redux/selector';

export const ContentCollectionCompletedUploads = memo(() => {
  const submittedClips = useSelector(contentCollectionSubmittedClipsSelector);

  const completedItemsToDisplay = useMemo(
    () =>
      submittedClips.map((item) => {
        const fileTrackingItem = convertUploadToFileTrackingPaneItem(item.upload);

        return (
          <FileStatusTrackingPanelListItemCompleted
            item={{
              ...fileTrackingItem,
              thumbnailSource: fileTrackingItem.thumbnailSource || item.assets.image,
              ...(item.title && { title: item.title }),
            }}
            key={item.id}
          />
        );
      }),
    [submittedClips],
  );

  return (
    <div className="max-h-[322px] w-[336px] rounded-4 ads:bg-raised bg-surface-1 shadow-file-status-pane">
      <FileStatusPanelItem
        avatar={<FileStatusIconCompleted />}
        buttons={undefined}
        className="px-4 py-3"
        subtitle={
          <FileStatusSubtitle className="truncate" data-testid="UPLOADER_SUBTITLE">
            {pluralize('item', submittedClips.length, true)} added
          </FileStatusSubtitle>
        }
        title={
          <FileStatusTitle className="font-semibold" data-testid="UPLOADER_TITLE">
            Submission complete
          </FileStatusTitle>
        }
      />

      <FileStatusTrackingPanelList
        abortedItems={[]}
        className="overflow-y-clip"
        completedItems={completedItemsToDisplay}
        erroredItems={[]}
        isUploaderOpen
        maxUploadHeight={250}
        ongoingItems={[]}
        onRetryAll={undefined}
        stoppedItems={[]}
      />
    </div>
  );
});

ContentCollectionCompletedUploads.displayName = 'ContentCollectionCompletedUploads';
